import {MultiCurrencyPriceFragment, PriceSummaryFragment} from '../../../../gql/graphql';
import {ModelContext} from '../../../../types/checkoutApp.types';
import {PriceModel} from '../Price.model';
import {SPECS} from '../../../../common/constants';

export class PriceSummaryModel {
  public delivery: PriceModel;
  public total: PriceModel;
  public tax: PriceModel;
  public additionalFees: PriceModel;
  public discount: PriceModel;

  constructor(params: PriceSummaryModel) {
    this.delivery = params.delivery;
    this.total = params.total;
    this.tax = params.tax;
    this.additionalFees = params.additionalFees;
    this.discount = params.discount;
  }

  public static fromCheckoutV1({
    priceSummary,
    deliveryTotalPriceAfterTax,
    modelContext,
  }: {
    priceSummary?: PriceSummaryFragment | null;
    deliveryTotalPriceAfterTax?: MultiCurrencyPriceFragment | null;
    modelContext: ModelContext;
  }) {
    return new PriceSummaryModel({
      delivery: PriceModel.fromCheckoutV1(
        modelContext.flowAPI.experiments.enabled(SPECS.ShowPriceSummaryByTaxIncluded) && modelContext.pricesIncludeTax
          ? deliveryTotalPriceAfterTax
          : priceSummary?.shipping,
        modelContext
      ),
      total: PriceModel.fromCheckoutV1(priceSummary?.total, modelContext),
      tax: PriceModel.fromCheckoutV1(priceSummary?.tax, modelContext),
      additionalFees: PriceModel.fromCheckoutV1(priceSummary?.additionalFees, modelContext),
      discount: PriceModel.fromCheckoutV1(priceSummary?.discount, modelContext),
    });
  }
}
